var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRadarSensor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "#e3e3e3",
  viewBox: "0 -960 960 960"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M311.5-153Q231-186 169-249l57-57q51 51 117 78.5T481-200t137.5-27T735-305l56 56q-63 63-143 96t-168 33-168.5-33M480-280q-56 0-107-21t-91-61l56-56q29 29 65.5 43.5T480-360t76.5-14.5T622-418l56 56q-40 40-91 61t-107 21M200-760v40h560v-40zm124 120 12 40h288l12-40zm12 120q-26 0-47-15.5T260-576l-20-64h-40q-33 0-56.5-23.5T120-720v-120h720v120q0 33-23.5 56.5T760-640h-40l-26 68q-9 23-29 37.5T620-520zM200-760v40z"
})));
export default SvgRadarSensor;